import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsAbstract } from "src/app/abstract/widgets/widgets.abstract";

export class WidgetsSectionModel extends WidgetsContainerAbstract {
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.SECTION;

    // Widget properties
    readonly badge: string = 'S';
    readonly icon: string = 'table_rows';
    readonly placeholderClassName: string = 'section-placeholder';
    name: string = 'Section';
    template = '';
    label: string = 'Section';
    description: string = 'Section description';

    // Level: 0 top level (1.). 1=Second level (1.1.). 2=Third level (1.1.1.)...
    level: number = 0;
    seq: number[] = [ 0 ];

    // A hidden section can have children, but it will not show
    hidden: boolean = false;
    seqHidden: boolean = false;

    // Initial Section Question
    isInitialQuestionEnabled: boolean = false;
    initialQuestionLabel: string = "";
    initialQuestionKey: string = "";
    isInitialQuestionPositive: boolean = true;

    // Children: QUESTIONS
    children: WidgetsAbstract[] = [];

    constructor() {
        super();
        this.id += this.badge;
    }

    // Serialize to JSON
    toJSON(): any {
        return {
            badge: this.badge,
            widgetType: this.widgetType,
            id: this.id,
            parentId: this.parentId,
            name: this.name,

            label: this.label,
            description: this.description ? this.description : undefined,
            level: this.level,
            seq: this.seq,
            hidden: this.hidden ? this.hidden : undefined,
            seqHidden: this.seqHidden ? this.seqHidden : undefined,
            isInitialQuestionEnabled: this.isInitialQuestionEnabled ? this.isInitialQuestionEnabled : undefined,
            initialQuestionLabel: this.isInitialQuestionEnabled ? this.initialQuestionLabel : undefined,
            initialQuestionKey: this.initialQuestionKey ? this.initialQuestionKey : undefined,
            isInitialQuestionPositive: this.isInitialQuestionEnabled ? this.isInitialQuestionPositive : undefined,
            template: this.template ? this.template : undefined,
            children: this.children
         };
    }

    /**
     * Clone this node from an origin.
     *
     * @param origin
     * @returns The cloned object.
     */
     cloneFrom(origin: WidgetsSectionModel): WidgetsSectionModel {
        // if (origin.parentId) {
        //     this.parentId = origin.parentId;
        // }
        this.name = origin.name;
        this.label = origin.label;
        if (origin.description) {
            this.description = origin.description;
        }
        this.level = origin.level;
        if (origin.seq && origin.seq.length > 0) {
            this.seq = [];
            origin.seq.forEach((value) => {
                this.seq.push(value);
            });
        }
        if (origin.hidden) {
            this.hidden = origin.hidden;
        }
        if (origin.seqHidden) {
            this.seqHidden = origin.seqHidden;
        }
        if (origin.isInitialQuestionEnabled) {
            this.isInitialQuestionEnabled = origin.isInitialQuestionEnabled;
        }
        if (origin.initialQuestionLabel) {
            this.initialQuestionLabel = origin.initialQuestionLabel;
        }
        if (origin.initialQuestionKey) {
            this.initialQuestionKey = origin.initialQuestionKey;
        }
        if (origin.isInitialQuestionPositive) {
            this.isInitialQuestionPositive = origin.isInitialQuestionPositive;
        }
        if (origin.template) {
            this.template = origin.template;
        }
        this.isSelected = origin.isSelected;
        return this;
    }

    hasSequence(): boolean{
        return true;
    }
}
